import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Icon from '@cb/solaris-react/Components/Content/Icon';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
const BurgerButtonOrLink = (props) => {
    const options = {
        className: props.className,
        onClick: props.action,
    };
    if (props.link) {
        if (props.link.includes('http://') || props.link.includes('https://')) {
            return (_jsxs("a", { ...options, href: props.link, target: "_blank", rel: " noreferrer", children: [_jsx(Icon, { name: props.icon }), props.children] }));
        }
        return (_jsxs(Link, { to: props.link, ...options, children: [_jsx(Icon, { name: props.icon }), props.children] }));
    }
    return (_jsxs("button", { ...options, children: [' ', _jsx(Icon, { name: props.icon }), props.children] }));
};
const StyledBurgerMenuItem = styled(BurgerButtonOrLink) `
	background-color: transparent;
	text-decoration: none;
	color: ${(props) => props.theme.schemes.primary.text};
	padding: ${(props) => props.theme.spacing.xs} ${(props) => props.theme.spacing.sm};
	border: none;
	display: flex;
	flex-direction: row;
	align-items: center;
	width: 100%;
	font-size: ${(props) => props.theme.typography.md};
	${(props) => (props.bgColor ? `background-color: ${props.bgColor}` : '')};

	${(props) => props.onlyShowInResponsiveMode
    ? `
         @media (min-width: ${props.theme.breakpoints.sm}) {
            display: none;
        }
    `
    : ''}

	&.active,
    :hover,
    :focus {
		background-color: ${(props) => props.theme.palette.shade6};
	}

	span {
		margin-left: ${(props) => props.theme.spacing.xs};
	}
`;
export default function BurgerMenuItem(props) {
    return (_jsx(StyledBurgerMenuItem, { ...props, children: _jsx("span", { children: props.text }) }));
}
//# sourceMappingURL=BurgerMenuItem.js.map